__turbopack_context__.v({
  "author": "styles-module-scss-module__SpSC7G__author",
  "container": "styles-module-scss-module__SpSC7G__container",
  "content": "styles-module-scss-module__SpSC7G__content",
  "hasNoAuthor": "styles-module-scss-module__SpSC7G__hasNoAuthor",
  "hero": "styles-module-scss-module__SpSC7G__hero",
  "image": "styles-module-scss-module__SpSC7G__image",
  "imageContainer": "styles-module-scss-module__SpSC7G__imageContainer",
  "pills": "styles-module-scss-module__SpSC7G__pills",
  "sectionContainer": "styles-module-scss-module__SpSC7G__sectionContainer",
});
